import { ArrowRight } from "lucide-react"
import { Link } from "react-router"
import { PageHero } from "@/components/PageHero"
import { Reveal } from "@/components/Reveal"
import { RemoteImage } from "@/components/RemoteImage"
import { Card } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { blogPosts } from "@/data/site"

export default function Blog(){return <>
  <PageHero eyebrow="Smart Drain Blog" title="Research, deployment notes and urban drainage thinking." description="A new content hub for explaining Smart Drain technology, field pilots, product development and the larger shift toward intelligent stormwater systems." />
</>}
